import PATHS from 'constants/paths';
import ENTITY_TYPES from './entity-types';

const { LEARNING_COMMUNITY, DEPARTMENT, ORGANIZATION } = ENTITY_TYPES;

const FIRST_COL_DATA = [
  {
    name: LEARNING_COMMUNITY.plural,
    url: PATHS.EXPLORE_LEARNING_COMMUNITIES,
  },
  {
    name: DEPARTMENT.plural,
    url: PATHS.EXPLORE_COLLECTIONS,
  },
  {
    name: ORGANIZATION.plural,
    url: PATHS.EXPLORE_ORGANIZATIONS,
  },
];

const SECOND_COL_DATA = [
  { name: 'About', url: '/about' },
  { name: 'Services', url: '/services' },
  { name: 'Refund Policy', url: '/refund-policy' },
];

const FOOTER_DATA = {
  FIRST_COL_DATA,
  SECOND_COL_DATA,
};

export default FOOTER_DATA;
